import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
  type = "website",
  author = "Olis - Mulheres que entendem",
  publishedTime,
  modifiedTime,
  section,
  tags,
}) => {
  const siteName = "Olis - Mulheres que entendem";
  const siteUrl = "https://olismulher.com"; // Ajuste para o domínio correto
  const defaultImage = "/img/logo/logo.png"; // Ajuste para o logo correto

  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const fullUrl = url ? `${siteUrl}${url}` : siteUrl;
  const fullImage = image ? `${siteUrl}${image}` : `${siteUrl}${defaultImage}`;

  const defaultDescription =
    "A Olis nasceu para simplificar seu cuidado em saúde da mulher: consultas online, com acolhimento, informação e praticidade. Sua saúde não pode mais esperar. Confira nossos serviços.";
  const finalDescription = description || defaultDescription;

  const defaultKeywords =
    "saúde da mulher, ginecologia online, consulta ginecologista, saúde feminina, telemedicina, ginecologia, obstetrícia, consulta online, saúde da mulher online, Olis";
  const finalKeywords = keywords || defaultKeywords;

  return (
    <Helmet>
      {/* Meta tags básicas */}
      <title>{fullTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      <meta name="author" content={author} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="pt_BR" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={fullImage} />

      {/* Meta tags adicionais para SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="googlebot" content="index, follow" />
      <meta name="language" content="pt-BR" />
      <meta name="revisit-after" content="7 days" />
      <meta name="distribution" content="global" />

      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />

      {/* Schema.org markup para rich snippets */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "MedicalOrganization",
          name: "Olis",
          description: finalDescription,
          url: fullUrl,
          logo: `${siteUrl}${defaultImage}`,
          image: fullImage,
          address: {
            "@type": "PostalAddress",
            addressCountry: "BR",
          },
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "customer service",
            availableLanguage: "Portuguese",
          },
          sameAs: [
            "https://www.instagram.com/olis.saude",
            "https://www.facebook.com/olis.saude",
          ],
          medicalSpecialty: ["Ginecologia", "Obstetrícia", "Saúde da Mulher"],
          serviceType: "Telemedicina",
          areaServed: "Brasil",
        })}
      </script>

      {/* Meta tags específicas para artigos/blog */}
      {type === "article" && (
        <>
          <meta property="article:published_time" content={publishedTime} />
          <meta property="article:modified_time" content={modifiedTime} />
          <meta property="article:section" content={section} />
          {tags &&
            tags.map((tag, index) => (
              <meta key={index} property="article:tag" content={tag} />
            ))}
        </>
      )}
    </Helmet>
  );
};

export default SEO;
